'use client'
import {
  Box,
  Button,
  Flex,
  HStack,
  Image,
  Input,
  Link,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useBreakpointValue,
} from '@chakra-ui/react'
import React, { useEffect, useRef, useState } from 'react'
import { toast } from 'sonner'
import { FormControl, FormErrorMessage } from '@chakra-ui/react'
import { FormProvider, useForm } from 'react-hook-form'
import { useUser } from '@/src/store/user-store'
import { useResendPwaOtpMutation, useValidatePwaOtpMutation } from '@/src/mutations/auth/otp-mutation'
import { GetTurnstileToken } from '@/src/lib/cloudflareTurnstile'
import CountdownTimer from '../resendTimer'
import { useToken } from '@/src/store/token-store'
interface NewsLetterTs {
  email: string
}
export default function IosPwaLoginSignupModal({
  isOpen,
  onClose,
  formType,
  type
}: {
  isOpen: boolean
  onClose: () => void
  formType: string
  type: string
}) {
  const methods = useForm<NewsLetterTs>()
  const copyToClipboardLink = () => {
    navigator.clipboard.writeText('https://www.lykstage.com/auth/signup')
    toast.success('Copied to clipboard')
  }
  const [email, setEmail] = useState('')
  const [isSubmitDone, setSubmitDone] = useState(false)
  const code1Ref = useRef<HTMLInputElement>(null)
  const code2Ref = useRef<HTMLInputElement>(null)
  const code3Ref = useRef<HTMLInputElement>(null)
  const code4Ref = useRef<HTMLInputElement>(null)
  const validateMutation = useValidatePwaOtpMutation()
  const resentOtpMutation = useResendPwaOtpMutation()
  const [time, setTime] = useState<number>(30);
  const [error, setErrorApi] = useState('')

  // Effect to handle countdown logic
  useEffect(() => {
    if (time > 0) {
      const timer = setTimeout(() => setTime(time - 1), 1000); // Decrease the time every second
      return () => clearTimeout(timer); // Cleanup the timeout on component unmount or time change
    }
  }, [time]);

  const onSubmitOtp = () => {
    const code1 = code1Ref.current?.value || ''
    const code2 = code2Ref.current?.value || ''
    const code3 = code3Ref.current?.value || ''
    const code4 = code4Ref.current?.value || ''
    const code = code1 + code2 + code3 + code4
    if (code.length !== 4) {
      setErrorApi('Please enter the verification code')
      return
    }
    validateMutation.mutate(
      { verifyCode: code, email: email },
      {
        onSuccess: (e) => {
          setTime(0)
          toast.success('Verification successful!')
          // router.push('/home')
        },
        onError: (error) => {
          toast.error(error.message)
          setErrorApi(error.message)
        },
      }
    )
  }

  const onRegenerate = () => {
    GetTurnstileToken("cft-resendOtp")
    if (time === 0) {
      resentOtpMutation.mutate({ email: email }, {
        onSuccess: () => {
          toast.success('Verification code sent!')
          setErrorApi('')
          setTime(30)
        },
        onError: (error) => {
          toast.error(error.message)
          setErrorApi(error.message)
        },
      })
    }
  }
  const {
    register,
    handleSubmit,
    setError,
    reset,
    formState: { errors },
  } = methods
  const onSubmit = () => {
    GetTurnstileToken("cft-resendOtp")
    resentOtpMutation.mutate({ email: email }, {
      onSuccess: () => {
        toast.success('Verification code sent!')
        setSubmitDone(true)
        setErrorApi('')
        setTime(30)
      },
      onError: (error) => {
        console.log(error)
        toast.error(error.message)
        setErrorApi(error.message)
      },
    })
  }
  return (
    <>
      <Box>
        <Modal
          isCentered={false}
          onClose={onClose}
          isOpen={isOpen}
          motionPreset="slideInBottom"
        >
          <ModalOverlay />
          <ModalContent
            borderTopRadius={18}
            position="fixed"
            bottom="0"
            margin="0 auto"
            width="100%"
            maxWidth="600px"
            display={{ base: 'block', sm: 'none' }}
          >

            <ModalHeader fontSize={'16px'} color={'#656565'} fontWeight={500}>Sign in with {type}</ModalHeader>
            <ModalCloseButton mt={2} color={'#656565'} />
            <hr />
            {
              formType === "signup" ?
                <ModalBody mb={4}>
                  <Box textAlign="center" mb={4}>
                    <Image
                      src={`/lykstage-logo.svg`}
                      alt="logo"
                      h="25px"
                      w="auto"
                      margin={'15px auto'}
                    />
                    <Text fontSize="16px" fontWeight={600} color={'#656565'}>
                      {type} sign up must be done through our web app on your browser.
                    </Text>
                    <Text mt={2} fontSize="13px" fontWeight={500} color={'#656565'}>
                      Please sign up with your desired {type} ID through web and come
                      back to this app and sign in.
                    </Text>
                  </Box>

                  <Box
                    mt={4}
                    py={2}
                    px={4}
                    border="1px solid"
                    borderColor="gray.200"
                    borderRadius="md"
                    bg="gray.50"
                  >
                    <Text fontSize="11px" fontWeight={500} color={'#656565'}>
                      Paste link in your browser
                    </Text>
                    <Box display="flex" justifyContent="space-between" alignItems="center" onClick={copyToClipboardLink}>
                      <Text color="blue.500">
                        www.lykstage.com/auth/signup
                      </Text>

                      <Box className="cursor-pointer">
                        <Image width={"25px"} ml={1} src={'/copy.svg'} alt="Copy" />
                      </Box>
                    </Box>
                  </Box>
                </ModalBody> :
                <>
                  {
                    isSubmitDone ?
                      <ModalBody mb={4}>
                        <Box textAlign="center" mb={4}>
                          <Text fontSize="16px" fontWeight={600} color={'#656565'} textAlign={'left'}>
                            Please enter the verification code sent to <Text color={'lyk-green'}>{email}</Text>
                          </Text>
                        </Box>
                        <Box >
                          <HStack spacing={[4]} mt={[5]}>
                            <Input
                              w={'69px'}
                              h={{
                                base: '78px',
                                md: '83px',
                              }}
                              borderColor={'lyk-green'}
                              rounded={'xl'}
                              type="number"
                              ref={code1Ref}
                              fontSize={{
                                base: '4xl',
                                md: '5xl',
                              }}
                              textAlign="center"
                              onFocus={() => code1Ref.current?.select()}
                              onClick={() => code1Ref.current?.select()}
                              onInput={(e) => {
                                if (e.currentTarget.value.length === 1) {
                                  code2Ref.current?.focus()
                                }
                              }}
                              onPaste={(e) => {
                                e.preventDefault()
                                const paste = e.clipboardData.getData('text')
                                const pasteArray = paste.split('')
                                if (pasteArray.length === 4) {
                                  code1Ref.current!.value = pasteArray[0]
                                  code2Ref.current!.value = pasteArray[1]
                                  code3Ref.current!.value = pasteArray[2]
                                  code4Ref.current!.value = pasteArray[3]
                                  code4Ref.current?.focus()
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  code1Ref.current?.focus()
                                }
                              }}
                            />
                            <Input
                              w={'69px'}
                              h={{
                                base: '78px',
                                md: '83px',
                              }}
                              borderColor={'lyk-green'}
                              rounded={'xl'}
                              fontSize={{
                                base: '4xl',
                                md: '5xl',
                              }}
                              type="number"
                              textAlign="center"
                              ref={code2Ref}
                              onFocus={() => code2Ref.current?.select()}
                              onClick={() => code2Ref.current?.select()}
                              onInput={(e) => {
                                if (e.currentTarget.value.length === 1) {
                                  code3Ref.current?.focus()
                                }
                              }}
                              onPaste={(e) => {
                                e.preventDefault()
                                const paste = e.clipboardData.getData('text')
                                const pasteArray = paste.split('')
                                if (pasteArray.length === 4) {
                                  code1Ref.current!.value = pasteArray[0]
                                  code2Ref.current!.value = pasteArray[1]
                                  code3Ref.current!.value = pasteArray[2]
                                  code4Ref.current!.value = pasteArray[3]
                                  code4Ref.current?.focus()
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  code2Ref.current!.value = ''
                                  code1Ref.current?.focus()
                                }
                              }}
                            />
                            <Input
                              w={'69px'}
                              h={{
                                base: '78px',
                                md: '83px',
                              }}
                              borderColor={'lyk-green'}
                              rounded={'xl'}
                              fontSize={{
                                base: '4xl',
                                md: '5xl',
                              }}
                              type="number"
                              ref={code3Ref}
                              textAlign="center"
                              onFocus={() => code3Ref.current?.select()}
                              onClick={() => code3Ref.current?.select()}
                              onInput={(e) => {
                                if (e.currentTarget.value.length === 1) {
                                  code4Ref.current?.focus()
                                }
                              }}
                              onPaste={(e) => {
                                e.preventDefault()
                                const paste = e.clipboardData.getData('text')
                                const pasteArray = paste.split('')
                                if (pasteArray.length === 4) {
                                  code1Ref.current!.value = pasteArray[0]
                                  code2Ref.current!.value = pasteArray[1]
                                  code3Ref.current!.value = pasteArray[2]
                                  code4Ref.current!.value = pasteArray[3]
                                  code4Ref.current?.focus()
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  code3Ref.current!.value = ''
                                  code2Ref.current?.focus()
                                }
                              }}
                            />
                            <Input
                              w={'69px'}
                              h={{
                                base: '78px',
                                md: '83px',
                              }}
                              borderColor={'lyk-green'}
                              rounded={'xl'}
                              fontSize={{
                                base: '4xl',
                                md: '5xl',
                              }}
                              type="number"
                              ref={code4Ref}
                              textAlign="center"
                              onFocus={() => code4Ref.current?.select()}
                              onClick={() => code4Ref.current?.select()}
                              onInput={(e) => {
                                if (e.currentTarget.value.length === 1) {
                                  code4Ref.current?.blur()
                                }
                              }}
                              onPaste={(e) => {
                                e.preventDefault()
                                const paste = e.clipboardData.getData('text')
                                const pasteArray = paste.split('')
                                if (pasteArray.length === 4) {
                                  code1Ref.current!.value = pasteArray[0]
                                  code2Ref.current!.value = pasteArray[1]
                                  code3Ref.current!.value = pasteArray[2]
                                  code4Ref.current!.value = pasteArray[3]
                                  code4Ref.current?.focus()
                                }
                              }}
                              onKeyDown={(e) => {
                                if (e.key === 'Backspace') {
                                  code4Ref.current!.value = ''
                                  code3Ref.current?.focus()
                                }
                              }}
                            />
                          </HStack>
                          <Text
                            as="p"
                            fontSize={{ base: 'sm', md: 'md' }}
                            color={'lyk-red'}
                            mt={2}
                            mb={4}
                          >
                            {error}
                          </Text>
                          <HStack display={'block'}>
                            <Box className={`w-full flex-1`}>
                              <Button
                                className={`font-regular mb-2  min-w-[200px] flex-1`}
                                borderRadius={"55px"}
                                onClick={onRegenerate}
                                isLoading={resentOtpMutation.isPending}
                                background={'lyk-green!important'}
                                opacity={time>0?0.5:1}
                                color={"white"}
                              >
                                Regenerate Code
                              </Button>
                              <CountdownTimer time={time} />
                            </Box>

                            <Button
                              onClick={onSubmitOtp}
                              isLoading={validateMutation.isPending}
                              background={'lyk-green!important'}
                              color={"white"}
                              className={`font-regular w-full min-w-[200px] flex-1 rounded-lg  tracking-wider mt-3`}
                            >
                              Proceed
                            </Button>
                          </HStack>
                        </Box>
                      </ModalBody> :
                      <ModalBody mb={4}>
                        <Box textAlign="center" mb={4}>
                          <Text fontSize="16px" fontWeight={600} color={'#656565'}>
                            Please enter the email associated with your {type} ID.
                          </Text>
                        </Box>
                        <Box >
                          <Text color="#525252" fontSize={'14px'} mb={2}>
                            Email *
                          </Text>
                          <FormProvider {...methods}>
                            <form name="pwaLogin" onSubmit={handleSubmit(onSubmit)}>
                              <FormControl
                                isRequired
                                isInvalid={!!errors.email}
                                display={'block'}
                              >
                                <Input
                                  id="emailNewsletter"
                                  {...register('email', {
                                    required: 'Email is required',
                                  })}
                                  type="email"
                                  value={email}
                                  onChange={(e) => setEmail(e.target.value)}
                                  placeholder="Your Email"
                                  className="min-w-[160px] rounded-md border-bordergray bg-white py-2 pl-8 pr-2 text-black md:min-w-[240px]"
                                />

                                <Button
                                  type="submit"
                                  className="font-regular mt-3 w-full rounded-lg"
                                  background={'lyk-green!important'}
                                  color={'white'}
                                  isLoading={resentOtpMutation.isPending}
                                >
                                  Continue
                                </Button>

                                <FormErrorMessage>
                                  <>{errors.email && errors.email?.message}</>
                                </FormErrorMessage>
                              </FormControl>
                            </form>
                          </FormProvider>
                        </Box>
                      </ModalBody>
                  }
                </>

            }

          </ModalContent>
        </Modal>
      </Box>
    </>
  )
}
